import { render, staticRenderFns } from "./AlreadySubmitted.vue?vue&type=template&id=43385309&scoped=true"
import script from "./AlreadySubmitted.vue?vue&type=script&lang=ts"
export * from "./AlreadySubmitted.vue?vue&type=script&lang=ts"
import style0 from "./AlreadySubmitted.vue?vue&type=style&index=0&id=43385309&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43385309",
  null
  
)

export default component.exports